export { default } from './skip-link'
export type { Props as SkipLinkProps } from './skip-link'
